import React, { useEffect, useState } from 'react';
import { Form, Spin } from 'components/ds';
import styled from 'styled-components';
import { ButtonLarge, DescriptionContainer, FooterDiv } from '../../../../../components/Css';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { useNavigate } from 'react-router-dom';
import ProgressStepper from 'components/ProgressStepper';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { usePostValidateOtp } from '../../../services/ValidationService';
import { useAuth } from 'auth/AuthProvider';

const ResendButton = styled(ButtonLarge)`
  height: 50px;
    font-size: var(--font-medium);
  width: 100%;
  margin-top: var(--spacing-small);
`;

const CircleInputContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 460px;
  margin: var(--spacing-regular) auto;
  overflow: visible;
  
  @media (max-width: 500px) {
    zoom: 0.6;
  }
`;

const Circle = styled.div`
  width: 50px;
  height: 50px;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
  border-radius: 50%;
  margin: 0 3px;
  border: 1px solid var(--colorBorderBase);
  background-color: white;
  z-index: 1;
`;

const HiddenInput = styled.input`
  position: absolute;
  height: 100%;
  top: 0;
  left: 36px;
  font-size: 33px;
  letter-spacing: 38.5px;
  padding-left: 44px;
  border: 0px !important;
  background-color: transparent;
  z-index: 2;
  cursor: pointer;

  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  &:focus {
    outline: none;
    box-shadow: none; /* Remove o destaque de foco */
  }
`;

const SignupValidationCode: React.FC = () => {
  const [form] = Form.useForm() as any;
  const [code, setCode] = useState('');
  const [seconds, setSeconds] = useState(42);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const { login } = useAuth();

  const navigate = useNavigate();
  const username = ApiLocalStorage.get('username');

  const { isLoading: isLoadingTemplate, data: pageConfig = {} } = useGetTemplate('signupValidationCode');
  const { mutateAsync: validateOtp, isLoading: isLoadingValidate } = usePostValidateOtp();

  const handleNext = async () => {

    try {
      const result = await validateOtp(code);
      await login(username, JSON.stringify(result), '');
      navigate(pageConfig.navigateTo());
    } catch (error) {
      console.error('Erro ao validar código:', error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, 6);
    setCode(value);
  };

  const handleResend = async () => {
    try {

      navigate(pageConfig.navigateBack());
      setSeconds(42);
      setIsResendDisabled(true);
    } catch (error) {
      console.error('Erro ao reenviar código:', error);
    }
  };

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);

      return () => clearTimeout(timer);
    }

    setIsResendDisabled(false);
  }, [seconds]);

  const submitForm = () => {
    form.submit();
  };

  if (isLoadingTemplate || isLoadingValidate) {
    return (
      <PageContainer>
        <Spin style={{ marginBottom: '65px' }} size="large" />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={pageConfig.title} navigateBack={pageConfig?.navigateBack?.()}>
      <ProgressStepper totalSteps={pageConfig.totalSteps} currentStep={pageConfig.currentStep} />
      <DescriptionContainer>Digite o código enviado</DescriptionContainer>
      <Form form={form} layout='vertical' onFinish={handleNext}>
        <CircleInputContainer>
          <HiddenInput
            type='number'
            value={code}
            onChange={handleInputChange}
            maxLength={6}
            autoFocus
            pattern='\d*'
          />
          {[...Array(6)].map((_, index) => (
            <Circle key={index}></Circle>
          ))}
        </CircleInputContainer>
      </Form>
      <FooterDiv>
        <ButtonLarge onClick={submitForm} disabled={code.length < 6}>
          {pageConfig.labelNext || 'Próximo'}
        </ButtonLarge>
        <ResendButton type='default' onClick={handleResend} disabled={isResendDisabled}>
          Reenviar em {seconds > 0 ? `${seconds} segundos` : 'agora'}
        </ResendButton>
      </FooterDiv>
    </PageContainer>
  );
};

export default SignupValidationCode;
